// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"LogoHeader_logoContainer__2U9h7","logo":"LogoHeader_logo__1Gciw","navigation":"LogoHeader_navigation__xmrLf"};